import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Img, { ImgProps } from "@insite/mobius/Img";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import React from "react";
import { css } from "styled-components";

const enum fields {
    slides = "slides",
    title = "title",
}

interface SlideModel {
    fields: {
        slideTitle: string;
        image: string;
        imageLink: LinkFieldValue;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.slides]: SlideModel[];
        [fields.title]: string;
    };
}

type Props = OwnProps;

export interface InfoCardStyles {
    Title?: InjectableCss;
    infoCardContainer?: GridContainerProps;
    infoCardImage?: ImgProps;
    infoCardLink?: LinkPresentationProps;
    infoCardDiv?: GridItemProps;
    slideTitle?: InjectableCss;
    imageWrapper?: InjectableCss;
    main?: InjectableCss;
}

export const infoCardStyles: InfoCardStyles = {
    infoCardContainer: {
        gap: 52,
        css: css`
            margin: 0 auto;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;
            /* ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: calc(100% - 40px) !important;
                        margin: 0 auto !important;
                    `,
                    css`
                        max-width: calc(100% - 40px) !important;
                        margin: 0 auto !important;
                    `,
                    css`
                        max-width: calc(100% - 40px) !important;
                        margin: 0 auto !important;
                    `,
                    css`
                        max-width: calc(100% - 80px) !important;
                        margin: 0 auto !important;
                    `,
                    css`
                        max-width: calc(100% - 80px) !important;
                        margin: 0 auto !important;
                    `,
                ])} */
        `,
    },
    infoCardDiv: {
        width: [12, 12, 12, 4, 4],
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            /* padding-left: 26px;
            padding-right: 26px; */
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 9px 20px;
                    `,
                    css`
                        padding: 9px 20px;
                    `,
                    css`
                        padding: 9px 20px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    infoCardLink: {
        css: css`
            width: 100%;
            span {
                width: 100%;
            }
        `,
    },
    imageWrapper: {
        css: css`
            width: 100%;
            display: flex;
            overflow: hidden;
            img {
                display: flex;
                object-fit: cover;
                width: 100%;
                height: 100%;
                aspect-ratio: 4.1/4.1;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            aspect-ratio: 3.4/3.4;
                            object-fit: cover;
                        `,
                        css`
                            aspect-ratio: 3.4/3.4;
                            object-fit: cover;
                        `,
                        css`
                            aspect-ratio: 3.4/3.4;
                            object-fit: cover;
                        `,
                        css`
                            aspect-ratio: 3.4/3.4;
                            object-fit: cover;
                        `,
                        css``,
                    ])}
            }
        `,
    },
    slideTitle: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 28px;
            margin-top: 16px;
            text-align: center;
            color: ${getColor("text.main")};
            text-transform: capitalize;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 8px;
                        font-size: ${TYPOGRAPHY.size.large};
                        line-height: ${TYPOGRAPHY.lineHeight.medium};
                    `,
                    css`
                        margin-top: 8px;
                        font-size: ${TYPOGRAPHY.size.large};
                        line-height: ${TYPOGRAPHY.lineHeight.medium};
                    `,
                    css`
                        margin-top: 8px;
                        font-size: ${TYPOGRAPHY.size.large};
                        line-height: ${TYPOGRAPHY.lineHeight.medium};
                    `,
                    null,
                    null,
                ])}
        `,
    },
    Title: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-size: ${TYPOGRAPHY.size.xxlarge};
            line-height: ${TYPOGRAPHY.lineHeight.xlmedium};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            text-align: center;
            text-transform: uppercase;
            color: ${getColor("text.main")};
            margin-bottom: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 14px;
                        font-size: ${TYPOGRAPHY.size.largest};
                        line-height: ${TYPOGRAPHY.lineHeight.xxmedium};
                        color: ${COLORS.featuredMobile};
                        padding-bottom: 14px;
                    `,
                    css`
                        margin-bottom: 14px;
                        font-size: ${TYPOGRAPHY.size.largest};
                        line-height: ${TYPOGRAPHY.lineHeight.xxmedium};
                        color: ${COLORS.featuredMobile};
                        padding-bottom: 14px;
                    `,
                    css`
                        margin-bottom: 14px;
                        font-size: ${TYPOGRAPHY.size.largest};
                        line-height: ${TYPOGRAPHY.lineHeight.xxmedium};
                        color: ${COLORS.featuredMobile};
                        padding-bottom: 14px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    main: {
        css: css`
            margin-top: 33px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 16px;
                    `,
                    css`
                        margin-top: 16px;
                    `,
                    css`
                        margin-top: 16px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
};

const styles = infoCardStyles;

const ImageGrid: React.FC<Props> = ({ fields }) => {
    const buttonLinks = useGetLinks(fields.slides, o => o.fields.imageLink).links;
    return (
        <StyledWrapper {...styles.main}>
            <StyledWrapper {...styles.Title}>{fields.title}</StyledWrapper>
            <GridContainer {...styles.infoCardContainer}>
                {fields.slides.map((slide, index) => (
                    <GridItem key={uniqueId()} {...styles.infoCardDiv}>
                        <Link href={buttonLinks[index].url} {...styles.infoCardLink}>
                            <StyledWrapper {...styles.imageWrapper}>
                                <Img
                                    src={slide.fields.image}
                                    {...styles.infoCardImage}
                                    altText={slide.fields.slideTitle || ""}
                                />
                            </StyledWrapper>
                        </Link>
                        <Link href={buttonLinks[index].url} role="button">
                            <StyledWrapper {...styles.slideTitle} aria-label={slide.fields.slideTitle}>
                                {slide.fields.slideTitle}
                            </StyledWrapper>
                        </Link>
                    </GridItem>
                ))}
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ImageGrid,
    definition: {
        group: "Basic",
        displayName: "Sur Fetured Category",
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Tittle",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                tooltip: "text tip",
                placeholder: "Title",
                isRequired: true,
                sortOrder: 0,
            },
            {
                name: fields.slides,
                editorTemplate: "ListField",
                defaultValue: [],
                fieldType: "General",
                getDisplay: (item: HasFields) => {
                    return item.fields.slideTitle;
                },
                fieldDefinitions: [
                    {
                        name: "slideTitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "image",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },
                    {
                        name: "imageLink",
                        editorTemplate: "LinkField",
                        displayName: "Redirect Link",
                        defaultValue: { type: "Page", value: "" },
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
